import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

export type SortDir = 'asc' | 'desc'

interface SortableThProps {
  label: string
  column: string
  sortBy: string | null
  sortDir: SortDir
  onSort: (column: string) => void
  numeric?: boolean
  className?: string
}

export function SortableTh({
  label,
  column,
  sortBy,
  sortDir,
  onSort,
  numeric = false,
  className = '',
}: SortableThProps) {
  const active = sortBy === column
  return (
    <th
      scope="col"
      className={`${numeric ? 'table__num' : ''} ${className}`.trim()}
      aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        className={`table__sort${active ? ' table__sort--active' : ''}`}
        onClick={() => onSort(column)}
      >
        <span>{label}</span>
        {active ? (
          sortDir === 'asc' ? (
            <ArrowUp size={14} strokeWidth={2} aria-hidden />
          ) : (
            <ArrowDown size={14} strokeWidth={2} aria-hidden />
          )
        ) : (
          <ArrowUpDown size={14} strokeWidth={2} aria-hidden />
        )}
      </button>
    </th>
  )
}
